import React from 'react';
import PropTypes from 'prop-types';

import { Box, Text } from '@nerdwallet/currency';
import OurValuesImageCarousel from './our-values-carousel';

import styles from './our-values.module.scss';

const OurValuesModuleTile = ({
  backgroundColor,
  title,
  copy,
  imageMobile,
  isImage,
  isMobile,
}) => {
  const tileBackgroundColor = {
    backgroundColor: `${backgroundColor}`,
  };
  const tileImageMobile = { backgroundImage: `url('${imageMobile}')` };

  const titleInHTML = () => ({ __html: title });

  const mobileOutput = (
    <div className={styles.valuesCarouselTile} style={tileBackgroundColor}>
      <div className={styles.valuesTitle}>
        <Text size="large" bold>
          {title}
        </Text>
      </div>
      <div className={styles.valuesCopy}>
        <Text size="default">{copy}</Text>
      </div>
      {imageMobile && (
        <div className={styles.imageMobile} style={tileImageMobile} />
      )}
    </div>
  );

  const desktopOutput = !isImage ? (
    <Box className={styles.valuesSmorgaContent}>
      {title && (
        <div className={styles.valuesTitle}>
          <Text size="large" bold>
            {/* eslint-disable-next-line react/no-danger */}
            <div dangerouslySetInnerHTML={titleInHTML()} />
          </Text>
        </div>
      )}
      {copy && (
        <div className={styles.valuesCopy}>
          <Text>{copy}</Text>
        </div>
      )}
    </Box>
  ) : (
    <Box className={styles.valuesSmorgaDesktopImageCont}>
      <OurValuesImageCarousel />
    </Box>
  );

  const returnTileOutput = isMobile ? (
    <Box className={styles.valuesCarouselTileContainer}>{mobileOutput}</Box>
  ) : (
    <div className={styles.valuesSmorgaTile} style={tileBackgroundColor}>
      {desktopOutput}
    </div>
  );

  return { ...returnTileOutput };
};

OurValuesModuleTile.propTypes = {
  backgroundColor: PropTypes.string,
  title: PropTypes.string,
  copy: PropTypes.string,
  imageMobile: PropTypes.string,
  isImage: PropTypes.bool,
  isMobile: PropTypes.bool,
};

export default OurValuesModuleTile;
